/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Source_BothInputs */

const vi_shop_account_source_both = /** @type {(inputs: Shop_Account_Source_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cả hai`)
};

/**

* @param {Shop_Account_Source_BothInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_source_both = /** @type {((inputs?: Shop_Account_Source_BothInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Source_BothInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_source_both(inputs)
});